export default __webpack_public_path__ + "static/media/ticket_point.dbe3d373.jpg";